import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../Miscelania/RequestApi';

import { Link } from 'react-router-dom';
import { Tabs, Tab } from 'react-bootstrap';
import Topo from '../Layout/Topo';
import Overlay from '../Miscelania/Overlay';

// Tabs
import PtbrCodesTab from './Elements/PtbrCodesTab';
import PtbrOperationsTab from './Elements/PtbrOperationsTab';
import PtbrFuelsTab from './Elements/PtbrFuelsTab';
import PtbrExternalLoadsTab from './Elements/PtbrExternalLoadsTab';
import FlightPtbrsTab from './Elements/FlightPtbrsTab';
import getLocale from '../../i18n/getLocale';

class PtbrIndex extends Component {
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'open',        
      },
      redirect_url: false,
      modal: false,
      loaded: 0,
      key: 1,
      ptbr_codes: {},
      ptbr_operations: {},
      ptbr_fuels: {},
      ptbr_external_loads: {},
      flight_ptbrs: {},
    };
    //Handlers
    this.handleAlert = this.handleAlert.bind(this);
    this.handleLoaded = this.handleLoaded.bind(this);
    this.handleMessage = this.handleMessage.bind(this);

    this.locale = getLocale();

    this.loadData = this.loadData.bind(this);
    this.refreshCodes = this.refreshCodes.bind(this);
    this.refreshOperations = this.refreshOperations.bind(this);
    this.refreshFuels = this.refreshFuels.bind(this);
    this.refreshExternalLoads = this.refreshExternalLoads.bind(this);
    this.refreshFlightPtbrs = this.refreshFlightPtbrs.bind(this);
  }

  // Handlers
  handleNavTab(state, key) {
    var change = {};
    change[state] = key;
    this.setState(change);
    this.setState({overlay: {message: '', type: '', status: ''}});
  }

  handleAlert(message, type, status, mode) {
    if(mode === 'reset') {
      this.setState({overlay: {message: '', type: '', status: 'closed'}});
    } else {
      this.setState({overlay: {message: message, type: type, status: status}});
    }
  }

  handleLoaded(state) {
    if(this.state.loaded !== 2) {
      this.setState({loaded: state});      
    }
  }

  handleMessage () {
    var message = localStorage.getItem("verify_message");
    if (message !== null && typeof message !== 'undefined') {
      message = JSON.parse(message);
      var self = this;
      self.setState({overlay: {message: message.alert_message, type: message.alert_type, status: 'open'}});
      localStorage.removeItem("verify_message");
    }
  }

  //LM
  componentDidMount () {
    this.refs.request_api.header();
  }

  componentDidUpdate(prevProps, prevState) {
    if(this.state.loaded === 1 && prevState.loaded === 0) {
      this.setState({loaded: 2}, this.loadData());
    }
  }

  loadData () {
    var self = this;
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      var url = config.get('api') + '/referencias/ptbr/codigos';
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'url', '/processos');
        if (responseJson.status === 'success') {
          self.setState({ptbr_codes: responseJson.data});
        }
      }).then(() => {
      var url = config.get('api') + '/referencias/ptbr/operacoes';
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson);
        if (responseJson.status === 'success') {
          self.setState({ptbr_operations: responseJson.data});
        }
      }).then(() => {
      var url = config.get('api') + '/referencias/ptbr/combustiveis';
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson);
        if (responseJson.status === 'success') {
          self.setState({ptbr_fuels: responseJson.data});
        }
      }).then(() => {
      var url = config.get('api') + '/referencias/ptbr/carga-externas';
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson);
        if (responseJson.status === 'success') {
          self.setState({ptbr_external_loads: responseJson.data});
        }
      }).then(() => {
      var url = config.get('api') + '/referencias/ptbr/justificativas/atraso';
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson);
        if (responseJson.status === 'success') {
          self.setState({flight_ptbrs: responseJson.data});
        }
      }).then(() => {
        self.setState({overlay: {message: '', type: '', status: 'closed'}});
        self.handleMessage();
      }); /* Overlay */ }); /* Lista de operacoes ptbr */ }); /* Lista de combustiveis ptbr */ }); /* Lista de carga externa ptbr */ }); /* Lista de justificativas ptbr */
    }); /* Lista de códigos ptbr */
  }

  refreshCodes (event) {
    var self = this;
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      var url = config.get('api') + '/referencias/ptbr/codigos';
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson);
        if (responseJson.status === 'success') {
          self.setState({ptbr_codes: responseJson.data,  modal: false});
        }
      }).then(() => {
        self.setState({overlay: {message: '', type: '', status: 'closed'}});
        self.handleAlert(event.message, event.status, 'open');
      }); /* Overlay */
    });
  }
  refreshOperations (event) {
    var self = this;
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      var url = config.get('api') + '/referencias/ptbr/operacoes';
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson);
        if (responseJson.status === 'success') {
          self.setState({ptbr_operations: responseJson.data,  modal: false});
        }
      }).then(() => {
        self.setState({overlay: {message: '', type: '', status: 'closed'}});
        self.handleAlert(event.message, event.status, 'open');
      }); /* Overlay */
    });
  }
  refreshFuels (event) {
    var self = this;
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      var url = config.get('api') + '/referencias/ptbr/combustiveis';
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson);
        if (responseJson.status === 'success') {
          self.setState({ptbr_fuels: responseJson.data,  modal: false});
        }
      }).then(() => {
        self.setState({overlay: {message: '', type: '', status: 'closed'}});
        self.handleAlert(event.message, event.status, 'open');
      }); /* Overlay */
    });
  }
  refreshExternalLoads (event) {
    var self = this;
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      var url = config.get('api') + '/referencias/ptbr/carga-externas';
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson);
        if (responseJson.status === 'success') {
          self.setState({ptbr_external_loads: responseJson.data,  modal: false});
        }
      }).then(() => {
        self.setState({overlay: {message: '', type: '', status: 'closed'}});
        self.handleAlert(event.message, event.status, 'open');
      }); /* Overlay */
    });
  }
  refreshFlightPtbrs (event) {
    var self = this;
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      var url = config.get('api') + '/referencias/ptbr/justificativas/atraso';
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson);
        if (responseJson.status === 'success') {
          self.setState({flight_ptbrs: responseJson.data,  modal: false});
        }
      }).then(() => {
        self.setState({overlay: {message: '', type: '', status: 'closed'}});
        self.handleAlert(event.message, event.status, 'open');
      }); /* Overlay */
    });
  }

  render() {
    var key_control = 1;
    var self = this;
    return (
<div>
  <Topo></Topo>
  <RequestApi ref={'request_api'} handleLoaded={this.handleLoaded} />
  <Overlay overlay={this.state.overlay} handleAlert={this.handleAlert} />
  <div className="container-liquid">
    <div className="conteudo">
      <h3 className="page-title pull-left">{this.locale.PTBR.ReferenciasPTBR.titulo}</h3>
      <div className="clearfix"></div>
      <hr/>
      <Tabs activeKey={this.state.key} onSelect={this.handleNavTab.bind(this, 'key')} id="controlled-tab-example">
        <Tab eventKey={1} title={this.locale.PTBR.ReferenciasPTBR.tabCodigosDaExportacaoXML.tituloTab}>
          <PtbrCodesTab handleAlert={this.handleAlert} refreshTable={this.refreshCodes} ptbr_codes={this.state.ptbr_codes} modal_props={this.state.modal} />
        </Tab>
        <Tab eventKey={2} title={this.locale.PTBR.ReferenciasPTBR.tabOperacoes.tituloTab}>
          <PtbrOperationsTab handleAlert={this.handleAlert} refreshTable={this.refreshOperations} ptbr_operations={this.state.ptbr_operations} modal_props={this.state.modal} />
        </Tab>
        <Tab eventKey={3} title={this.locale.PTBR.ReferenciasPTBR.tabCombustivel.tituloTab}>
          <PtbrFuelsTab handleAlert={this.handleAlert} refreshTable={this.refreshFuels} ptbr_fuels={this.state.ptbr_fuels} modal_props={this.state.modal} />
        </Tab>
        <Tab eventKey={4} title={this.locale.PTBR.ReferenciasPTBR.tabCargaExterna.tituloTab}>
          <PtbrExternalLoadsTab handleAlert={this.handleAlert} refreshTable={this.refreshExternalLoads} ptbr_external_loads={this.state.ptbr_external_loads} modal_props={this.state.modal} />
        </Tab>
        <Tab eventKey={5} title={this.locale.PTBR.ReferenciasPTBR.tabJustificativasDeAtraso.tituloTab}>
          <FlightPtbrsTab handleAlert={this.handleAlert} refreshTable={this.refreshFlightPtbrs} flight_ptbrs={this.state.flight_ptbrs} modal_props={this.state.modal} />
        </Tab>
      </Tabs>
    </div>
  </div>
</div>
    );
  }
}

export default PtbrIndex;



// WEBPACK FOOTER //
// ./src/Components/Ptbr/PtbrIndex.js